export default [
  {
    path: '/admin/group-tracking',
    name: 'group-tracking',
    meta: { requiresAuth: true },
    component: () => import('@/pages/sale/group-tracking/index.vue'),
  },
  {
    path: '/admin/group-tracking/map-view',
    name: 'group-tracking-map-view',
    meta: { requiresAuth: true },
    component: () => import('@/pages/sale/group-tracking/mapView.vue')
  }
]
